import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import Panel from './ManagePanel';

@observer
export default class SaleManageSection extends Component {
  static propTypes = {
    ui: MobxPropTypes.observableObject,
    store: MobxPropTypes.observableObject,
  };

  render() {
    const { ui, sale, user } = this.props;
    return (
      ui.currentPanel === 'saleManage' && (
        <Panel
          isOpen={true}
          sale={sale}
          user={user}
          onClose={() => ui.closePanel()}
        />
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleManageSection/index.jsx